import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "next-themes";

const API = process.env.REACT_APP_BACKEND_URL;
const HORIZONTAL_LOGO = "/assets/logo-horizontal.png";

const InstagramIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

const TikTokIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const WhatsAppIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const DiscordIcon = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
);

const defaultFooter = {
  copyright: "\u00a9 2024 Lord of the Quiz. Todos os direitos reservados.",
  socialLinks: [
    { platform: "instagram", url: "https://www.instagram.com/lordofthequiz/" },
    { platform: "tiktok", url: "https://www.tiktok.com/@lordofthequizoficial" },
    { platform: "whatsapp", url: "http://wa.me/5521997024314?text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20os%20servi%C3%A7os%20do%20Lord%20of%20the%20Quiz." },
    { platform: "discord", url: "https://discord.gg/pASXmrMTVh" },
  ],
  email: "contato@lordofthequiz.com.br",
};

const socialIcons = {
  instagram: InstagramIcon,
  tiktok: TikTokIcon,
  whatsapp: WhatsAppIcon,
  discord: DiscordIcon,
};

function fixMojibake(value) {
  if (typeof value !== "string") return value;

  let normalized = value;
  for (let attempt = 0; attempt < 2; attempt += 1) {
    if (!/[\u00C3\u00C2\u00E2\uFFFD]/.test(normalized)) break;

    try {
      normalized = decodeURIComponent(escape(normalized));
    } catch {
      normalized = normalized.replace(/\u00C2/g, "").replace(/\u00E2/g, "");
      break;
    }
  }

  normalized = normalized.replace(/\u00C2/g, "");

  const replacements = {
    "Ol?": "Olá",
    "ol?": "olá",
    "n?o": "não",
    "N?o": "Não",
    "voc?": "você",
    "Voc?": "Você",
    "est?": "está",
    "Est?": "Está",
    "per?odo": "período",
    "Per?odo": "Período",
    "conte?do": "conteúdo",
    "Conte?do": "Conteúdo",
    "aprova??o": "aprovação",
    "Aprova??o": "Aprovação",
    "modera??o": "moderação",
    "Modera??o": "Moderação",
    "sugest?o": "sugestão",
    "Sugest?o": "Sugestão",
    "revis?o": "revisão",
    "Revis?o": "Revisão",
    "pr?ximo": "próximo",
    "Pr?ximo": "Próximo",
    "hor?rio": "horário",
    "Hor?rio": "Horário",
    "cr?ditos": "créditos",
    "Cr?ditos": "Créditos",
    "t?tulo": "título",
    "T?tulo": "Título",
    "conclu?do": "concluído",
    "Conclu?do": "Concluído",
    "conclu?mos": "concluímos",
    "Conclu?mos": "Concluímos",
    "benef?cios": "benefícios",
    "Benef?cios": "Benefícios",
    "interrup??o": "interrupção",
    "Interrup??o": "Interrupção",
    "cobran?a": "cobrança",
    "Cobra?a": "Cobrança",
    "altera??o": "alteração",
    "Altera??o": "Alteração",
  };

  for (const [broken, fixed] of Object.entries(replacements)) {
    normalized = normalized.replaceAll(broken, fixed);
  }

  return normalized;
}

export default function Footer() {
  const [footerData, setFooterData] = useState(defaultFooter);
  const { resolvedTheme } = useTheme();
  const isLight = resolvedTheme === "light";

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const res = await fetch(`${API}/api/cms/settings`);
        if (!res.ok) return;
        const data = await res.json();
        if (!data.footer) return;

        setFooterData({
          copyright: fixMojibake(data.footer.copyright || defaultFooter.copyright),
          socialLinks: data.footer.socialLinks?.length > 0 ? data.footer.socialLinks : defaultFooter.socialLinks,
          email: fixMojibake(data.footer.email || defaultFooter.email),
        });
      } catch (error) {
        console.error("Error loading footer:", error);
      }
    };

    fetchFooter();
  }, []);

  return (
    <footer className="bg-black/90 backdrop-blur-md border-t border-white/10 mt-auto" data-testid="main-footer">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img
              src={HORIZONTAL_LOGO}
              alt="Lord of the Quiz"
              className="mb-4 h-16 w-auto object-contain"
              style={isLight ? { filter: "brightness(0) saturate(100%)" } : undefined}
            />
            <p className="text-zinc-400 text-sm">O melhor quiz show da cidade.</p>
          </div>

          <div>
            <h3 className="font-nunito font-bold text-[#fccf1f] text-lg mb-4">{"Links r\u00e1pidos"}</h3>
            <ul className="space-y-2">
              <li><Link to="/eventos" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">Eventos</Link></li>
              <li><Link to="/jogos" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">Jogos online</Link></li>
              <li><Link to="/quizmaker" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">Quiz Maker</Link></li>
              <li><Link to="/suporte" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">Suporte e FAQ</Link></li>
              <li><Link to="/termos" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">{"Termos e condi\u00e7\u00f5es"}</Link></li>
              <li><Link to="/politica-de-privacidade" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">{"Pol\u00edtica de privacidade"}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-nunito font-bold text-[#fccf1f] text-lg mb-4">Institucional</h3>
            <ul className="space-y-2">
              <li><Link to="/contratar" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">Contratar</Link></li>
              <li><Link to="/temas" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">Alertas de temas</Link></li>
              <li><Link to="/perguntas" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">Banco de perguntas</Link></li>
              <li><Link to="/sobre" className="text-zinc-400 hover:text-[#fccf1f] transition-colors">{"Sobre n\u00f3s"}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-nunito font-bold text-[#fccf1f] text-lg mb-4">Redes sociais</h3>
            <div className="flex gap-4">
              {footerData.socialLinks.map((link, index) => {
                const IconComponent = socialIcons[link.platform];
                if (!IconComponent) return null;

                return (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-zinc-400 hover:text-[#fccf1f] transition-colors"
                    data-testid={`social-${link.platform}`}
                    title={link.platform.charAt(0).toUpperCase() + link.platform.slice(1)}
                  >
                    <IconComponent size={24} />
                  </a>
                );
              })}
            </div>

            {footerData.email && (
              <a href={`mailto:${footerData.email}`} className="text-zinc-400 hover:text-[#fccf1f] transition-colors text-sm mt-4 block break-all">
                {fixMojibake(footerData.email)}
              </a>
            )}
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center">
          <p className="text-zinc-500 text-sm">{fixMojibake(footerData.copyright)}</p>
        </div>
      </div>
    </footer>
  );
}
